import { PropsWithChildren } from "react";

const FooterLink = ({ to, children }: PropsWithChildren<{ to: string }>) => (
  <a href={to} className="px-2" target="_blank" rel="noreferrer">
    {children}
  </a>
);

export default FooterLink;
